import { useState } from 'react';
import { Link } from 'react-router-dom';
import { LinkPreview } from './LinkPreview';

interface PostContentProps {
  content: string;
}

const URL_REGEX = /https?:\/\/[^\s]+/;

export function PostContent({ content }: PostContentProps) {
  // Track which URLs loaded previews successfully (hide raw URL text for those)
  const [loadedPreviews, setLoadedPreviews] = useState<Set<string>>(new Set());

  // Split on @mentions, #hashtags, and URLs
  const parts = content.split(/(https?:\/\/[^\s]+|@\w+|#\w+)/g);

  return (
    <div className="text-zinc-200 whitespace-pre-wrap break-words leading-relaxed font-body text-[15px]">
      {parts.map((part, index) => {
        if (part.startsWith('@')) {
          const username = part.slice(1);
          return (
            <Link
              key={index}
              to={`/@${username}`}
              className="text-neon hover:text-neon-dim transition-colors font-medium"
              onClick={(e) => e.stopPropagation()}
            >
              {part}
            </Link>
          );
        }
        if (part.startsWith('#')) {
          const tag = part.slice(1);
          return (
            <Link
              key={index}
              to={`/hashtag/${tag}`}
              className="text-neon/80 hover:text-neon transition-colors"
              onClick={(e) => e.stopPropagation()}
            >
              {part}
            </Link>
          );
        }
        if (URL_REGEX.test(part)) {
          return (
            <span key={index}>
              {!loadedPreviews.has(part) && (
                <a
                  href={part}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-neon hover:text-neon-dim transition-colors break-all"
                  onClick={(e) => e.stopPropagation()}
                >
                  {part}
                </a>
              )}
              <LinkPreview
                url={part}
                onLoad={() => setLoadedPreviews((prev) => new Set(prev).add(part))}
              />
            </span>
          );
        }
        return <span key={index}>{part}</span>;
      })}
    </div>
  );
}
